(() => {
  const init = (root = document) => {
    root.querySelectorAll('.ci-review-carousel').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      const track = carousel.querySelector('.ci-review-track');
      const slides = [...carousel.querySelectorAll('.ci-review-card')];
      const previous = carousel.querySelector('.ci-review-prev');
      const next = carousel.querySelector('.ci-review-next');
      if (!track || !slides.length || !previous || !next) return;

      carousel.dataset.ready = 'true';
      let current = 0;
      let timer;
      let hovered = false;
      const autoplayDisabled = window.matchMedia('(max-width:940px), (hover:none), (prefers-reduced-motion:reduce)');
      const controller = new AbortController();
      const { signal } = controller;
      const visibleCount = () => window.innerWidth <= 700 ? 1 : window.innerWidth <= 1100 ? 2 : 3;
      const maxIndex = () => Math.max(0, slides.length - visibleCount());
      const update = () => {
        current = Math.min(current, maxIndex());
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const distance = slides[0].getBoundingClientRect().width + gap;
        track.style.transform = `translateX(${-current * distance}px)`;
      };

      const stop = () => window.clearInterval(timer);
      const advance = () => {
        current = current >= maxIndex() ? 0 : current + 1;
        update();
      };
      const start = () => {
        stop();
        if (autoplayDisabled.matches || hovered || carousel.contains(document.activeElement) || document.hidden || maxIndex() === 0) return;
        timer = window.setInterval(advance, 4600);
      };

      previous.addEventListener('click', () => {
        current = current <= 0 ? maxIndex() : current - 1;
        update();
        start();
      }, { signal });
      next.addEventListener('click', () => {
        advance();
        start();
      }, { signal });
      carousel.addEventListener('mouseenter', () => { hovered = true; stop(); }, { signal });
      carousel.addEventListener('mouseleave', () => { hovered = false; start(); }, { signal });
      carousel.addEventListener('focusin', stop, { signal });
      carousel.addEventListener('focusout', () => queueMicrotask(start), { signal });
      autoplayDisabled.addEventListener('change', start, { signal });
      document.addEventListener('visibilitychange', start, { signal });
      window.addEventListener('resize', () => {
        update();
        start();
      }, { signal });
      document.addEventListener('shopify:section:unload', (event) => {
        if (!(event.target instanceof Element) || !event.target.contains(carousel)) return;
        stop();
        controller.abort();
        delete carousel.dataset.ready;
      }, { signal });
      update();
      start();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
